import {Col, Form} from "react-bootstrap";
import * as React from "react";

interface Props {
  label: string,
  subLabel: string,
  value: string | undefined,
  setValue: (valueToSet: string) => void,
}

function DateField(props: Props) {
  return (
      <div className="form-row">
        <Col>
          <Form.Group className="form-element" controlId={props.label}>
            <Form.Label><small><b><span>{props.label}</span></b></small></Form.Label>
            <Form.Control
                type="date"
                name={props.label}
                placeholder=""
                value={props.value}
                onChange={(e) => props.setValue(e.target.value)}
            />
            <Form.Text className="text-muted">
              {props.subLabel}
            </Form.Text>
          </Form.Group>
        </Col>
      </div>
  )
}

export default DateField;